// =============================================================
// MD Link · Unidosis · Data model + Pricing engine
// Ported from Felipe's Opus Pac calculator.
// =============================================================

export const FMT = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
export const FMT0 = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
});
export const N = new Intl.NumberFormat("es-CR");

export const money = (v) => FMT.format(v || 0);
export const money0 = (v) => FMT0.format(v || 0);
export const unit = (v) =>
    "$" +
    (v || 0).toLocaleString("en-US", {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
    });

export const MODE_LABELS = {
    contado: "Venta directa",
    financiamiento: "Financiamiento",
    alquiler: "Alquiler",
    comodato: "Comodato",
};

export const DEFAULTS = {
    params: {
        logEq: 0.12,
        arancelEq: 0.03,
        margenEq: 0.3,
        logCo: 0.08,
        arancelCo: 0.07,
        margenCo: 0.5,
        otrosImpl: 0.03,
        otrosMant: 0.03,
        otrosImprev: 0.015,
        otrosGastos: 0.015,
        tasaFin: 0.15,
        tasaAlq: 0.18,
        iva: 0.13,
    },
    plazo: { 1: 0, 2: 0.04, 3: 0.07, 4: 0.1 },
    tiers: [
        { mult: 1, desc: 0 },
        { mult: 3, desc: 0.05 },
        { mult: 6, desc: 0.1 },
        { mult: 12, desc: 0.15 },
    ],
};

export const EQUIPOS = [
    { id: "corinaE", nombre: "Opus Corina E", desc: "Cortador robótico de blísters y unitarizadora (blísteres y ampollas)", cost: 41900, fam: "corina" },
    { id: "corinaPro", nombre: "Opus Corina Pro", desc: "Unitarización robótica de alto volumen", cost: 54000, fam: "corina" },
    { id: "nina", nombre: "Opus Nina", desc: "Unitarización semiautomática de lotes pequeños y kits", cost: 24300, fam: "nina" },
    { id: "pickBaseNina", nombre: "Opus Pick BASE + Nina", desc: "Picking + unitarización integrada", cost: 51150, fam: "nina" },
    { id: "pikOne", nombre: "Opus PIK One", desc: "Estación de picking unidosis", cost: 46200, fam: "nina" },
    { id: "pikOneMini", nombre: "Opus PIK One Mini", desc: "Estación de picking compacta", cost: 39600, fam: "nina" },
    { id: "mat", nombre: "Opus MAT", desc: "Módulo automático de trazabilidad", cost: 27500, fam: "nina" },
    { id: "mk5", nombre: "Opus MK5", desc: "Empacadora de sachets unidosis", cost: 52030, fam: "mk5" },
    { id: "flag", nombre: "Opus Flag", desc: "Etiquetado autosticker flag para identificación", cost: 52030, fam: "flag" },
    { id: "ibfill", nombre: "Opus IB-Fill", desc: "Llenado de bolsas IV", cost: 13530, fam: "nina", margen: 0.35 },
    { id: "inst", nombre: "Instalación técnica", desc: "Servicio de instalación y puesta en marcha", cost: 4000, fam: "servicio", tipo: "servicio" },
    { id: "aduana", nombre: "Despacho de aduana", desc: "Gestión aduanal", cost: 360, fam: "servicio", tipo: "servicio" },
];

export const CONSUMIBLES = {
    corina: {
        label: "Bobinas Corina E / Corina Pro",
        items: [
            { id: "c70x65sc", nombre: "70 × 65 — BOPP Sin Color", moq: 15000, cost: 272.75 },
            { id: "c70x65", nombre: "70 × 65 — BOPP", moq: 10000, cost: 225.32 },
            { id: "c70x65mp", nombre: "70 × 65 — Metalizado + Fotosensible", moq: 5000, cost: 147.8 },
            { id: "c70x65p", nombre: "70 × 65 — BOPP + Fotosensible", moq: 10000, cost: 207.77 },
            { id: "c70x97sc", nombre: "70 × 97 — BOPP Sin Color", moq: 10000, cost: 289.37 },
            { id: "c70x97", nombre: "70 × 97 — BOPP", moq: 10000, cost: 332.72 },
            { id: "c70x97mp", nombre: "70 × 97 — Metalizado + Fotosensible", moq: 2500, cost: 85.17 },
            { id: "c70x97p", nombre: "70 × 97 — BOPP + Fotosensible", moq: 1000, cost: 289.37 },
            { id: "c70x130sc", nombre: "70 × 130 — BOPP Sin Color", moq: 7500, cost: 312.02 },
            { id: "c70x130", nombre: "70 × 130 — BOPP", moq: 5000, cost: 238.88 },
            { id: "c70x130mp", nombre: "70 × 130 — Metalizado + Fotosensible", moq: 5000, cost: 238.88 },
            { id: "c70x130p", nombre: "70 × 130 — BOPP + Fotosensible", moq: 5000, cost: 238.0 },
            { id: "cribbon", nombre: "Ribbon (cinta termotransferencia)", moq: 20000, cost: 42.53 },
        ],
    },
    nina: {
        label: "Bobinas Opus Nina (Coex)",
        items: [
            { id: "n70x70sc", nombre: "70 × 70 — Coex Sin Color", moq: 5000, cost: 82.88 },
            { id: "n70x70", nombre: "70 × 70 — Coex", moq: 5000, cost: 107.8 },
            { id: "n70x70p", nombre: "70 × 70 — Coex + Fotosensible", moq: 5000, cost: 82.88 },
            { id: "n70x100sc", nombre: "70 × 100 — Coex Sin Color", moq: 3500, cost: 92.16 },
            { id: "n70x100", nombre: "70 × 100 — Coex", moq: 3500, cost: 102.13 },
            { id: "n70x100p", nombre: "70 × 100 — Coex + Fotosensible", moq: 3500, cost: 92.16 },
            { id: "n70x140sc", nombre: "70 × 140 — Coex Sin Color", moq: 3000, cost: 107.8 },
            { id: "n70x140", nombre: "70 × 140 — Coex", moq: 3000, cost: 116.58 },
            { id: "n70x140p", nombre: "70 × 140 — Coex + Fotosensible", moq: 3000, cost: 107.8 },
            { id: "n140x230", nombre: "140 × 230 — Coex", moq: 2000, cost: 102.13 },
            { id: "nribbon", nombre: "Ribbon (cinta termotransferencia)", moq: 20000, cost: 38.89 },
        ],
    },
    flag: {
        label: "Autosticker Flag (25 × 75 mm)",
        items: [
            { id: "fwhite", nombre: "Flag blanco sin franja", moq: 5000, cost: 97.72 },
            { id: "fstripe", nombre: "Flag con franja (rojo/azul/verde/amarillo/rosa)", moq: 5000, cost: 115.46 },
            { id: "fred", nombre: "Flag totalmente rojo", moq: 5000, cost: 115.46 },
            { id: "fribbon", nombre: "Ribbon Videojet (termotransferencia)", moq: 5000, cost: 115.46 },
        ],
    },
    mk5: {
        label: "Sachets Opus MK5",
        items: [
            { id: "mk5sach", nombre: "Sachet fotosensible 50 mm — sin franja", moq: 2364, cost: 223.21 },
            { id: "mk5red", nombre: "Sachet fotosensible 50 mm — franja roja", moq: 2364, cost: 223.21 },
            { id: "mk5yel", nombre: "Sachet fotosensible 50 mm — franja amarilla", moq: 2364, cost: 223.21 },
            { id: "mk5cry", nombre: "Sachet BOPP cristal 50 mm — sin franja", moq: 3636, cost: 198.65 },
            { id: "mk5tube", nombre: "Kit de tubos esterilizados (Ibetek)", moq: 1, cost: 13.5 },
            { id: "mk5ribbon", nombre: "Ribbon Makem-Imaje (termotransferencia)", moq: 22000, cost: 42.53 },
        ],
    },
};

export const deepClone = (o) => JSON.parse(JSON.stringify(o));

export function autoFolio() {
    const d = new Date();
    return (
        "OP-" +
        d.getFullYear() +
        ("0" + (d.getMonth() + 1)).slice(-2) +
        ("0" + d.getDate()).slice(-2) +
        "-" +
        Math.floor(Math.random() * 900 + 100)
    );
}

export function freshState() {
    return {
        tipo: "PRIV",
        cliente: "",
        contacto: "",
        folio: autoFolio(),
        vigencia: 30,
        eq: {},
        eqOverrides: {}, // {id: {cost, otrosFijos, listaManual}}
        consOverrides: {}, // {id: {cost, moq, unitManual}}
        mode: "contado",
        contado: { desc: 0 },
        fin: { enganche: 20, plazo: 24 },
        alq: { anios: 2 },
        com: { anios: 1, tasa: null },
        plazoCons: "1",
        cons: {},
        settings: deepClone(DEFAULTS),
        internal: false,
    };
}

// -----------------------------------------------------------------
// helpers: apply overrides
// -----------------------------------------------------------------
export function eqWithOverrides(state, e) {
    const ov = (state.eqOverrides || {})[e.id] || {};
    return {
        ...e,
        cost: ov.cost != null ? ov.cost : e.cost,
        otrosFijos: ov.otrosFijos != null ? ov.otrosFijos : (e.otrosFijos || 0),
        _listaManual: ov.listaManual != null ? ov.listaManual : undefined,
    };
}
export function consWithOverrides(state, c) {
    const ov = (state.consOverrides || {})[c.id] || {};
    return {
        ...c,
        cost: ov.cost != null ? ov.cost : c.cost,
        moq: ov.moq != null ? ov.moq : c.moq,
        _unitManual: ov.unitManual != null ? ov.unitManual : undefined,
    };
}

export function findConsRaw(id) {
    for (const f of Object.keys(CONSUMIBLES)) {
        const c = CONSUMIBLES[f].items.find((x) => x.id === id);
        if (c) return c;
    }
    return null;
}

// -----------------------------------------------------------------
// Pricing engine
// -----------------------------------------------------------------
export function equipoVenta(state, eq) {
    const P = state.settings.params;
    const margen = eq.margen != null ? eq.margen : P.margenEq;
    const compraTotal = eq.cost * (1 + P.logEq + P.arancelEq);
    return compraTotal / (1 - margen);
}
export function equipoOtrosDetalle(state, eq) {
    const P = state.settings.params;
    const venta = equipoVenta(state, eq);
    const impl = eq.cost * (P.otrosImpl || 0);
    const mant = eq.cost * (P.otrosMant || 0);
    const imprev = eq.cost * (1 + P.logEq) * (P.otrosImprev || 0);
    const gastos = venta * (P.otrosGastos || 0);
    const fijos = eq.otrosFijos || 0;
    return { impl, mant, imprev, gastos, fijos, total: impl + mant + imprev + gastos + fijos };
}
export function equipoOtros(state, eq) {
    return equipoOtrosDetalle(state, eq).total;
}
export function equipoLista(state, eqRaw) {
    const eq = eqWithOverrides(state, eqRaw);
    if (eq._listaManual != null) return eq._listaManual;
    return equipoVenta(state, eq) + equipoOtros(state, eq);
}
export function equipoCostoFull(state, eqRaw) {
    const eq = eqWithOverrides(state, eqRaw);
    const P = state.settings.params;
    return eq.cost * (1 + P.logEq + P.arancelEq);
}
export function consUnitBase(state, cRaw) {
    const c = consWithOverrides(state, cRaw);
    if (c._unitManual != null) return c._unitManual;
    const P = state.settings.params;
    const rollo = (c.cost * (1 + P.logCo + P.arancelCo)) / (1 - P.margenCo);
    return rollo / c.moq;
}
export function consUnitCost(state, cRaw) {
    const c = consWithOverrides(state, cRaw);
    const P = state.settings.params;
    return (c.cost * (1 + P.logCo + P.arancelCo)) / c.moq;
}

export function volDiscount(state, cRaw, vol) {
    const c = consWithOverrides(state, cRaw);
    const tiers = state.settings.tiers;
    let d = 0;
    for (const t of tiers) {
        if (vol >= c.moq * t.mult) d = t.desc;
    }
    return d;
}
export function plazoDiscount(state) {
    if (state.mode === "comodato") return 0;
    return state.settings.plazo[state.plazoCons] || 0;
}

export function PMT(principal, annualRate, n) {
    const r = annualRate / 12;
    if (r === 0) return principal / n;
    return (principal * r) / (1 - Math.pow(1 + r, -n));
}

export function selEquipos(state) {
    return EQUIPOS.filter((e) => (state.eq[e.id] || 0) > 0).map((e) => {
        const eOv = eqWithOverrides(state, e);
        return { ...eOv, qty: state.eq[e.id] };
    });
}
export function selFamilias(state) {
    const f = new Set();
    selEquipos(state).forEach((e) => {
        if (e.fam !== "servicio") f.add(e.fam);
    });
    return [...f];
}

export function equiposSubtotal(state) {
    return selEquipos(state).reduce((s, e) => s + equipoLista(state, e) * e.qty, 0);
}
export function equiposCosto(state) {
    return selEquipos(state).reduce((s, e) => s + equipoCostoFull(state, e) * e.qty, 0);
}

export function consLines(state) {
    const out = [];
    const dp = plazoDiscount(state);
    for (const fam of selFamilias(state)) {
        const grp = CONSUMIBLES[fam];
        if (!grp) continue;
        for (const cRaw of grp.items) {
            const vol = +(state.cons[cRaw.id] || 0);
            if (vol > 0) {
                const c = consWithOverrides(state, cRaw);
                const base = consUnitBase(state, cRaw);
                const dv = volDiscount(state, cRaw, vol);
                const u = base * (1 - dv) * (1 - dp);
                out.push({
                    c,
                    fam,
                    vol,
                    base,
                    dv,
                    dp,
                    u,
                    annual: u * vol,
                    annualCost: consUnitCost(state, cRaw) * vol,
                });
            }
        }
    }
    return out;
}
export function consAnnual(state) {
    return consLines(state).reduce((s, l) => s + l.annual, 0);
}
export function consAnnualCost(state) {
    return consLines(state).reduce((s, l) => s + l.annualCost, 0);
}

export function famTitle(fa) {
    return fa.equipos.map((e) => `${e.qty > 1 ? e.qty + "× " : ""}${e.nombre}`).join(" + ");
}

export function comodatoCalc(state) {
    const years = state.com.anios || 1;
    const meses = years * 12;
    const P = state.settings.params;
    const tasa = state.com.tasa != null ? state.com.tasa : P.tasaFin;
    const famData = {};
    let serviceValue = 0;
    let totalEqNonSvc = 0;
    selEquipos(state).forEach((e) => {
        if (e.fam === "servicio") {
            serviceValue += equipoLista(state, e) * e.qty;
            return;
        }
        const f = e.fam;
        if (!famData[f])
            famData[f] = {
                fam: f,
                equipos: [],
                equipList: 0,
                consLines: [],
                annualUnits: 0,
                consAnnualValue: 0,
                consAnnualCost: 0,
            };
        famData[f].equipos.push(e);
        famData[f].equipList += equipoLista(state, e) * e.qty;
        totalEqNonSvc += equipoLista(state, e) * e.qty;
    });
    for (const f in famData) {
        const grp = CONSUMIBLES[f];
        if (!grp) continue;
        for (const cRaw of grp.items) {
            const vol = +(state.cons[cRaw.id] || 0);
            if (vol > 0) {
                const sale = consUnitBase(state, cRaw);
                famData[f].consLines.push({ c: cRaw, vol, sale });
                famData[f].annualUnits += vol;
                famData[f].consAnnualValue += sale * vol;
                famData[f].consAnnualCost += consUnitCost(state, cRaw) * vol;
            }
        }
    }
    const families = [];
    let pkgAll = 0, unitsAll = 0, valorAll = 0;
    for (const f in famData) {
        const d = famData[f];
        const svcShare = totalEqNonSvc > 0 ? serviceValue * (d.equipList / totalEqNonSvc) : 0;
        const equipBase = d.equipList + svcShare;
        const equipTotal = equipBase > 0 ? PMT(equipBase, tasa, meses) * meses : 0;
        const totalUnits = d.annualUnits * years;
        const consTotal = d.consAnnualValue * years;
        const packageTotal = equipTotal + consTotal;
        const flatUnit = totalUnits > 0 ? packageTotal / totalUnits : null;
        families.push({
            ...d,
            title: famTitle(d),
            svcShare,
            equipBase,
            equipTotal,
            totalUnits,
            consTotal,
            packageTotal,
            flatUnit,
            monthly: meses > 0 ? packageTotal / meses : 0,
        });
        pkgAll += packageTotal;
        unitsAll += totalUnits;
        valorAll += equipBase;
    }
    return {
        years,
        meses,
        tasa,
        families,
        serviceValue,
        packageTotal: pkgAll,
        totalUnits: unitsAll,
        valor: valorAll,
        monthly: meses > 0 ? pkgAll / meses : 0,
        consTotal: families.reduce((s, f) => s + f.consTotal, 0),
        consAnnualCost: families.reduce((s, f) => s + f.consAnnualCost, 0),
        equipTotal: families.reduce((s, f) => s + f.equipTotal, 0),
    };
}

export function ivaRate(state) {
    return state.tipo === "CCSS" ? 0 : state.settings.params.iva;
}
